import { pickBy } from '@/utils'
import CompBackground from './comp-background.vue'
import AttrItem from './attr-item.vue'
import CompsStyle from '../../comps/comps-style.vue'

function normalizeCategoryId(data) {
  if (data == null || data === '') return ''
  if (Array.isArray(data)) {
    const first = data[0] || {}
    return first.category_id || first.id || ''
  }
  if (typeof data === 'object') {
    return data.category_id || data.id || ''
  }
  return data
}

export default {
  /** 不可用 `article`：与原生 <article> 标签冲突，:is 会渲染成 HTML 元素而非本组件 */
  name: 'articleBlock',
  setting: [
    {
      label: '楼层',
      key: 'floor_var',
      component: 'input',
      value: ''
    },
    {
      label: '组件背景',
      key: 'background',
      component: function (h, { key }) {
        return <CompBackground v-model={this.value[key]} uuid={this.value.uuid} />
      },
      value: {
        color: '',
        imageUrl: ''
      }
    },
    {
      label: '内边距',
      key: 'padded',
      component: function (h, { key }) {
        return (
          <CompsStyle
            showBgsetting={false}
            v-model={this.value[key]}
            uuid={this.value.uuid}
            showLabel={false}
          />
        )
      },
      value: {
        paddedt: 10,
        paddedb: 10,
        paddedl: 10,
        paddedr: 10
      }
    },
    {
      label: '选择分类',
      key: 'data',
      component: function (h, { key }) {
        return <AttrItem v-model={this.value[key]} uuid={this.value.uuid} />
      },
      value: ''
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data } = v
    const source = config || {}
    return {
      name,
      ...base,
      background: source.background || {
        color: '',
        imageUrl: ''
      },
      padded: source.padded || {
        paddedt: 10,
        paddedb: 10,
        paddedl: 10,
        paddedr: 10
      },
      data: normalizeCategoryId(data)
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          floor_var: 'floor_var'
        })
      },
      config: (v) => {
        return pickBy(v, {
          background: 'background',
          padded: 'padded'
        })
      },
      data: (val) => normalizeCategoryId(val.data)
    })
  }
}
